import React from 'react';
import styled from 'styled-components';

import ExpandingTextInput from '../ExpandingTextInput';
import { IUEvent } from '../../lib/event';

import { TAppElkEventAnswer, TAppElkEventQuestion, TAppElkInvitee } from 'TProtocol/prototypes/events/messages';

interface Props {
  event: IUEvent;
  question: TAppElkEventQuestion;
  invitee: TAppElkInvitee;
  onAnswerChange: (invitee: TAppElkInvitee, answer: TAppElkEventAnswer) => void;
}

const EditableAnswer = ({ question, invitee, onAnswerChange }: Props) => {
  const answer = invitee.answers?.find(
    (answer) => answer.questionUuid === question.questionUuid
  ) ?? new TAppElkEventAnswer({ questionUuid: question.questionUuid, answer: '' });

  const handleAnswerChange = (value: string) => {
    answer.answer = value;
    onAnswerChange(invitee, answer);
  };

  return <Container>
    <QuestionText>{question.question}</QuestionText>
    <TextInputContainer>
      <ExpandingTextInput
        label="Your response"
        value={answer.answer}
        charLimit={1000}
        onChange={(value) => handleAnswerChange(value)}
        textColor="var(--shine-text-color)"
        noVertMargin={true}
      />
    </TextInputContainer>
  </Container>;
};

const Container = styled.div`
  font-size: 24px;
  display: flex;
  flex-direction: column;
`;

const TextInputContainer = styled.div`
  margin: 5px;
`;

const QuestionText = styled.div`
  font-size: 18px;
  font-weight: 300;
`;

export default EditableAnswer;
